import React from "react"
import ReactModalOpener from '../../../components/ReactModalOpener'

const appendUrlParam = (url, params) => url.indexOf("?") !== -1 ? `${url}&${params}` : `${url}?${params}`

export default function RulesAgreement({ order, checked, onChange }) {
  const link = (
    <ReactModalOpener href={order.terms_url} remote={appendUrlParam(order.terms_url, "layout=modal")}>
      {I18n.t(`fe.rules_agreement.${st.app_config.kind}.link`)}
    </ReactModalOpener>
  )
  
  return (
    <div className="form-checkbox-row">
      <div className="checkbox">
        <label>
          <input type="checkbox" checked={checked} onChange={onChange} />
          {I18n.tt(`fe.rules_agreement.${st.app_config.kind}.label`, { link })}
          <span> *</span>
        </label>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/RulesAgreement.jsx